// import { useEffect } from 'react'
// import { useSelector, useDispatch } from 'react-redux'
// import { THEME_ENUM } from 'constants/theme.constant'
// import { setMode } from 'store/theme/themeSlice'

// function useDarkMode() {

//     const mode = useSelector((state) => state.theme.mode)
//     const { MODE_DARK, MODE_LIGHT } = THEME_ENUM

//     const isEnabled = mode === MODE_DARK 

//     const dispatch = useDispatch()
//     const onModeChange = mode => dispatch(setMode(mode))

//     useEffect(() => {
//         if (window === undefined) {
//             return
//         }
//         const root = window.document.documentElement
//         root.classList.remove(isEnabled ? MODE_LIGHT : MODE_DARK)
//         root.classList.add(isEnabled ? MODE_DARK : MODE_LIGHT)
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [isEnabled])
                                              
//     return [isEnabled, onModeChange]
// }

// export default useDarkMode
import { useEffect, useState } from 'react';

const useDarkMode = () => {
    // Initialize state based on localStorage value or default to 'light'
    const [isDark, setIsDark] = useState(() => {
        const savedMode = localStorage.getItem('theme');
        return savedMode ? savedMode : 'light'; // Default to 'light'
    });

    useEffect(() => {
        // Apply the theme to the document's root element
        const root = document.documentElement;
        const newMode = isDark === 'dark' ? 'dark' : 'light';

        // Update class based on the current mode
        root.classList.remove('light', 'dark');
        root.classList.add(newMode);

        // Save the theme to localStorage
        localStorage.setItem('theme', isDark);
    }, [isDark]);

    return [isDark, setIsDark];
};

export default useDarkMode;
